/*
    notifica per richieste ajax in corso
*/
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

/*
    action utilizzati per login CalAmp
*/
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

/*
    action utilizzati subito dopo il login - per recuperare info sull'utente corrente
*/
export const LOAD_CURRENTUSER_REQUEST = 'LOAD_CURRENTUSER_REQUEST';
export const LOAD_CURRENTUSER_SUCCESS = 'LOAD_CURRENTUSER_SUCCESS';
export const LOAD_CURRENTUSER_ERROR = 'LOAD_CURRENTUSER_ERROR';

/*
    action usati durante l'init dell'applicazione
*/
export const LOAD_INIT_CURRENTUSER_REQUEST = 'LOAD_INIT_CURRENTUSER_REQUEST';
export const LOAD_INIT_CURRENTUSER_SUCCESS = 'LOAD_INIT_CURRENTUSER_SUCCESS';
export const LOAD_INIT_CURRENTUSER_ERROR = 'LOAD_INIT_CURRENTUSER_ERROR';

/*
    action per caricare in memoria le liste basilari
*/
export const LOAD_APPDATA = 'LOAD_APPDATA';

/*
    ricerca subaccounts
*/
export const FETCH_SUBACCOUNTS_REQUEST = 'FETCH_SUBACCOUNTS_REQUEST';
export const FETCH_SUBACCOUNTS_SUCCESS = 'FETCH_SUBACCOUNTS_SUCCESS';
export const FETCH_SUBACCOUNTS_ERROR = 'FETCH_SUBACCOUNTS_ERROR';

export const GET_SYSTEMUNITS_REQUEST = 'GET_SYSTEMUNITS_REQUEST';
export const GET_SYSTEMUNITS_SUCCESS = 'GET_SYSTEMUNITS_SUCCESS';
export const GET_SYSTEMUNITS_ERROR = 'GET_SYSTEMUNITS_ERROR';

/*
    Entity services
*/

export const GET_DEVICE_REQUEST = 'GET_DEVICE_REQUEST';
export const GET_DEVICE_SUCCESS= 'GET_DEVICE_SUCCESS';
export const GET_DEVICE_ERROR = 'GET_DEVICE_ERROR';

export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_SUCCESS= 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_ERROR = 'GET_ACCOUNT_ERROR';

/*
    action per la ricerca di ICN
*/
export const SEARCH_ICNLIST_CANCELREQUEST = 'SEARCH_ICNLIST_CANCELREQUEST';
export const SEARCH_ICNLIST_REQUEST = 'SEARCH_ICNLIST_REQUEST';
export const SEARCH_ICNLIST_SUCCESS= 'SEARCH_ICNLIST_SUCCESS';
export const SEARCH_ICNLIST_ERROR = 'SEARCH_ICNLIST_ERROR';

export const SEARCH_MAPICNLIST_REQUEST = 'SEARCH_MAPICNLIST_REQUEST';
export const SEARCH_MAPICNLISTWITHPARAMS_REQUEST = 'SEARCH_MAPICNLISTWITHPARAMS_REQUEST';
export const SEARCH_MAPICNLIST_SUCCESS= 'SEARCH_MAPICNLIST_SUCCESS';
export const SEARCH_MAPICNLIST_ERROR = 'SEARCH_MAPICNLIST_ERROR';

export const GET_ICNITEM_REQUEST = 'GET_ICNITEM_REQUEST';
export const GET_ICNITEM_SUCCESS= 'GET_ICNITEM_SUCCESS';
export const GET_ICNITEM_ERROR = 'GET_ICNITEM_ERROR';

export const GET_ICNPLUS_REQUEST = 'GET_ICNPLUS_REQUEST';
export const GET_ICNPLUS_SUCCESS= 'GET_ICNPLUS_SUCCESS';
export const GET_ICNPLUS_ERROR = 'GET_ICNPLUS_ERROR';

export const GET_ICNACCELERATION_REQUEST = 'GET_ICNACCELERATION_REQUEST';
export const GET_ICNACCELERATION_SUCCESS= 'GET_ICNACCELERATION_SUCCESS';
export const GET_ICNACCELERATION_ERROR = 'GET_ICNACCELERATION_ERROR';

export const GET_ICNSPEED_REQUEST = 'GET_ICNSPEED_REQUEST';
export const GET_ICNSPEED_SUCCESS= 'GET_ICNSPEED_SUCCESS';
export const GET_ICNSPEED_ERROR = 'GET_ICNSPEED_ERROR';

export const GET_BOMLIST_REQUEST = 'GET_BOMLIST_REQUEST';
export const GET_BOMLIST_SUCCESS= 'GET_BOMLIST_SUCCESS';
export const GET_BOMLIST_ERROR = 'GET_BOMLIST_ERROR';

export const SEND_EVENTCLASSIFICATIONUPDATE_REQUEST = 'SEND_EVENTCLASSIFICATIONUPDATE_REQUEST';
export const SEND_EVENTCLASSIFICATIONUPDATE_SUCCESS= 'SEND_EVENTCLASSIFICATIONUPDATE_SUCCESS';
export const SEND_EVENTCLASSIFICATIONUPDATE_ERROR = 'SEND_EVENTCLASSIFICATIONUPDATE_ERROR';

/*
    google actions
*/

export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS= 'GET_TIMEZONE_SUCCESS';
export const GET_TIMEZONE_ERROR = 'GET_TIMEZONE_ERROR';

/*
    Crashboxx web api actions
*/

export const GET_PDOF_REQUEST = 'GET_PDOF_REQUEST';
export const GET_PDOF_SUCCESS= 'GET_PDOF_SUCCESS';
export const GET_PDOF_ERROR = 'GET_PDOF_ERROR';

export const GET_PREDICTIVEIMAGE_REQUEST = 'GET_PREDICTIVEIMAGE_REQUEST';
export const GET_PREDICTIVEIMAGE_SUCCESS= 'GET_PREDICTIVEIMAGE_SUCCESS';
export const GET_PREDICTIVEIMAGE_ERROR = 'GET_PREDICTIVEIMAGE_ERROR';

export const DOWNLOAD_SINGLEEXCEL_REQUEST = 'DOWNLOAD_SINGLEEXCEL_REQUEST';
export const DOWNLOAD_SINGLEEXCEL_SUCCESS= 'DOWNLOAD_SINGLEEXCEL_SUCCESS';
export const DOWNLOAD_SINGLEEXCEL_ERROR = 'DOWNLOAD_SINGLEEXCEL_ERROR';

export const DOWNLOAD_SINGLEPDF_REQUEST = 'DOWNLOAD_SINGLEPDF_REQUEST';
export const DOWNLOAD_SINGLEPDF_SUCCESS= 'DOWNLOAD_SINGLEPDF_SUCCESS';
export const DOWNLOAD_SINGLEPDF_ERROR = 'DOWNLOAD_SINGLEPDF_ERROR';

export const DOWNLOAD_SINGLECSV_REQUEST = 'DOWNLOAD_SINGLECSV_REQUEST';
export const DOWNLOAD_SINGLECSV_SUCCESS= 'DOWNLOAD_SINGLECSV_SUCCESS';
export const DOWNLOAD_SINGLECSV_ERROR = 'DOWNLOAD_SINGLECSV_ERROR';

export const DOWNLOAD_LISTEXCEL_REQUEST = 'DOWNLOAD_LISTEXCEL_REQUEST';
export const DOWNLOAD_LISTEXCEL_SUCCESS= 'DOWNLOAD_LISTEXCEL_SUCCESS';
export const DOWNLOAD_LISTEXCEL_ERROR = 'DOWNLOAD_LISTEXCEL_ERROR';

export const DOWNLOAD_ALLLISTEXCEL_REQUEST = 'DOWNLOAD_ALLLISTEXCEL_REQUEST';
export const DOWNLOAD_ALLLISTEXCEL_SUCCESS= 'DOWNLOAD_ALLLISTEXCEL_SUCCESS';
export const DOWNLOAD_ALLLISTEXCEL_ERROR = 'DOWNLOAD_ALLLISTEXCEL_ERROR';

export const DOWNLOAD_LISTPDF_REQUEST = 'DOWNLOAD_LISTPDF_REQUEST';
export const DOWNLOAD_LISTPDF_SUCCESS= 'DOWNLOAD_LISTPDF_SUCCESS';
export const DOWNLOAD_LISTPDF_ERROR = 'DOWNLOAD_LISTPDF_ERROR';

export const DOWNLOAD_ALLLISTPDF_REQUEST = 'DOWNLOAD_ALLLISTPDF_REQUEST';
export const DOWNLOAD_ALLLISTPDF_SUCCESS= 'DOWNLOAD_ALLLISTPDF_SUCCESS';
export const DOWNLOAD_ALLLISTPDF_ERROR = 'DOWNLOAD_ALLLISTPDF_ERROR';

export const DOWNLOAD_LISTCSV_REQUEST = 'DOWNLOAD_LISTCSV_REQUEST';
export const DOWNLOAD_LISTCSV_SUCCESS= 'DOWNLOAD_LISTCSV_SUCCESS';
export const DOWNLOAD_LISTCSV_ERROR = 'DOWNLOAD_LISTCSV_ERROR';

export const DOWNLOAD_ALLLISTCSV_REQUEST = 'DOWNLOAD_ALLLISTCSV_REQUEST';
export const DOWNLOAD_ALLLISTCSV_SUCCESS= 'DOWNLOAD_ALLLISTCSV_SUCCESS';
export const DOWNLOAD_ALLLISTCSV_ERROR = 'DOWNLOAD_ALLLISTCSV_ERROR';

export const JASPER_LOGIN_REQUEST = 'JASPER_LOGIN_REQUEST';
export const JASPER_LOGIN_SUCCESS= 'JASPER_LOGIN_SUCCESS';
export const JASPER_LOGIN_ERROR = 'JASPER_LOGIN_ERROR';

export const JASPER_OPTIONS_REQUEST = 'JASPER_OPTIONS_REQUEST';
export const JASPER_OPTIONS_SUCCESS= 'JASPER_OPTIONS_SUCCESS';
export const JASPER_OPTIONS_ERROR = 'JASPER_OPTIONS_ERROR';

export const JASPER_LOADREPORT_REQUEST = 'JASPER_LOADREPORT_REQUEST';
export const JASPER_LOADREPORT_SUCCESS= 'JASPER_LOADREPORT_SUCCESS';
export const JASPER_LOADREPORT_ERROR = 'JASPER_LOADREPORT_ERROR';

export const APP_SAVEAPPLICATION_SUCCESS= 'APP_SAVEAPPLICATION_SUCCESS';

export const GRID_SAVEROWINDEX = 'GRID_SAVEROWINDEX';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js